import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { isEmpty, getTextWithHighlight } from '@/pages/intelligence/utils/commonUtils';
import './index.scss';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';

export default function EntityRenderer(tablePayload: any, keyword = '') {
  const payload = tablePayload?.cvm;
  if (isEmpty(payload)) return null;
  const publisher = payload?.publisher || '';
  const releaseTime = payload?.releaseTime;
  const highlightGameTitleNode = getTextWithHighlight(payload?.gameName?.trim(), keyword);
  const gameTitleNode = (
    <div className="dbi-add-entities-first-row-comp">
      <div className="dbi-add-entities-first-row-comp_title">
        <EllipsisHover text={highlightGameTitleNode || '-'} />
      </div>
      <SvgIcon className="dbi-add-entities-first-row-comp_platform-icon" type="other-icon" />
    </div>
  );
  const cvm = {
    gametitle: gameTitleNode,
    img: payload?.cover || '',
    text: releaseTime ? `Release ${releaseTime}` : '',
    tipList: publisher ? [publisher] : [],
  };

  // @ts-ignore
  return (
    <FirstRow
      cvm={cvm}
      rihgtClickToJumpHref={getDetailGameOverviewPath(payload?.app_id || payload?.gameId, payload?.entity_type)}
    />);
}
